import { defaultEntityState } from '@core/state/entities/entity';
import { IReviewerAnnotationStats } from '@core/state/entities/reviewer-annotation-stats/reviewer-annotation-stats.entity';
import { createReducer, on } from '@ngrx/store';
import { stageActions } from '@core/actions/stage.actions';
import { mergeEntityState } from '@core/state/entities/entity.helpers';
import { entityKey } from '@core/state/entities/entity-name-map';
import { projectDetailActions } from '@core/actions/project-detail.actions';

export const reviewerAnnotationStatsEntityReducer = createReducer(
  defaultEntityState<IReviewerAnnotationStats>(),
  on(
    stageActions.receivedStageReviewerStats,
    projectDetailActions.receivedProjectReviewerStats,
    (state, props) =>
      mergeEntityState(entityKey.reviewerAnnotationStats, state, props)
  )
);
